import { render, staticRenderFns } from "./PenaltyAssessment.vue?vue&type=template&id=8b89f6e4"
import script from "./PenaltyAssessment.vue?vue&type=script&lang=js"
export * from "./PenaltyAssessment.vue?vue&type=script&lang=js"
import style0 from "./PenaltyAssessment.vue?vue&type=style&index=0&id=8b89f6e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports